import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-bookseller-print-javak',
  templateUrl: './bookseller-print-javak.component.html',
  styleUrls: ['./bookseller-print-javak.component.scss']
})
export class BooksellerPrintJavakComponent implements OnInit {

  printJavakData: any[] = [];

  selectedBook: any;
  todayDate: string = '';

  bookedtncpoies = 0;

  totalBooksellers = 0;
  totalBookCopies = 0;
  totalComplimentaryCopies = 0;
  totalSponsorCopies = 0;
  totalJyda = 0;
  grandTotal = 0;

  totalShillak = 0;

  private readonly STORAGE_KEY = 'javak_jyda_data';

  constructor(
    private dialogRef: MatDialogRef<BooksellerPrintJavakComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) {}

  ngOnInit(): void {

    const today = new Date();

    this.todayDate =
      String(today.getDate()).padStart(2, '0') + '/' +
      String(today.getMonth() + 1).padStart(2, '0') + '/' +
      today.getFullYear();

    this.loadDistributionData();
  }

  // ================= LOAD DATA =================
  loadDistributionData(): void {

    const payload = {
      bookwise: this.data?.filters?.bookwise || '',
      distribution_mode: this.data?.filters?.distribution_mode || '',
      sub_distribution_mode: this.data?.filters?.sub_distribution_mode || '',
      start_date: this.data?.filters?.start_date || '',
      end_date: this.data?.filters?.end_date || ''
    };

    this.selectedBook = payload.bookwise;

    this.service.getDistributionRepresentativeSBhetHastewise3(payload)
      .subscribe({
        next: (res: any) => {

          this.printJavakData = (Array.isArray(res) ? res : []).map((r: any) => ({
            ...r,

            total_booksellers: Number(r.total_booksellers) || 0,
            normal_copies: Number(r.normal_copies || r.total_book_copies) || 0,
            complimentary_copies: Number(r.complimentary_copies) || 0,
            sponsor_copies: Number(r.sponsor_copies) || 0,
            jyda: Number(r.jyda) || 0,

            editing: false   // ✅ important for input edit stability
          }));

          this.loadJydaFromLocalStorage();

          if (this.printJavakData.length > 0) {
            this.bookedtncpoies =
              Number(this.printJavakData[0].bookedtncpoies || 0);
          }

          this.calculateTotals();
        },
        error: (err) => console.error(err)
      });
  }

  // ================= TOTAL CALCULATION =================
  calculateTotals(): void {

    this.totalBooksellers = 0;
    this.totalBookCopies = 0;
    this.totalComplimentaryCopies = 0;
    this.totalSponsorCopies = 0;
    this.totalJyda = 0;
    this.grandTotal = 0;

    this.printJavakData.forEach(row => {

      const booksellers = Number(row.total_booksellers) || 0;
      const copies = Number(row.normal_copies) || 0;
      const comp = Number(row.complimentary_copies) || 0;
      const sponsor = Number(row.sponsor_copies) || 0;
      const jyda = Number(row.jyda) || 0;

      this.totalBooksellers += booksellers;
      this.totalBookCopies += copies;
      this.totalComplimentaryCopies += comp;
      this.totalSponsorCopies += sponsor;
      this.totalJyda += jyda;

      // ✅ SAME LOGIC AS HTML
      this.grandTotal += copies + jyda + comp + sponsor;
    });

    this.totalShillak =
      Math.max(0, (this.bookedtncpoies || 0) - this.grandTotal);
  }

  // ================= JYDA SAVE =================
  saveJyda(row: any, index: number): void {

    row.editing = false;
    row.jyda = Number(row.jyda || 0);

    const saved = JSON.parse(localStorage.getItem(this.STORAGE_KEY) || '{}');

    saved[index] = row.jyda;

    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(saved));

    this.calculateTotals();
  }

  // ================= LOAD JYDA =================
  loadJydaFromLocalStorage(): void {

    const saved = JSON.parse(localStorage.getItem(this.STORAGE_KEY) || '{}');

    this.printJavakData.forEach((row, i) => {
      row.jyda = Number(saved[i] ?? row.jyda ?? 0);
    });
  }

  // ================= CLOSE =================
  close(): void {
    this.dialogRef.close();
  }
}